export enum PossibleLeagueSortOptions {
    totalPoints = 'totalPoints',
    roundPoints = 'roundPoints',
}